import Mark from "mark.js";

export const highlightText = (docElement: string, text: string) => {
  const markOptions = {
    ignoreJoiners: true,
    acrossElements: true,
    diacritics: true,
    exclude: [".no-highlight *"]
  };
  const markInstance = new Mark(document.querySelectorAll(`.${docElement}`));
  markInstance.unmark({
    done: () => {
      markInstance.mark(text, markOptions);
    }
  });
};
